
<div class="text-alert">
  <i class="fas fa-exclamation-triangle"></i>
  No se puede mostrar el contenido de esta página en un iframe.
</div>